<div class="summary-stats">
  <h4>Batch Summary Stats</h4>
  <ul class="stats-list">
    <li>number of scans: {{ totalScans() }}</li>
    <li>number of scans with values: {{ scansWithAnyValue() }}</li>

    <li>
      avarage dE: {{ format(dEStats().avg) }}
      (over {{ dEStats().count }}/{{ dEStats().total }} scans with usable values / total scans)
    </li>
    <li>
      avarage dC: {{ format(dCStats().avg) }}
      (over {{ dCStats().count }}/{{ dCStats().total }} scans with usable values / total scans)
    </li>

    <li>
      max dC: {{ format(dCStats().max) }}
      @if (dCStats().maxScans.length) {
        (scan:
        @for (s of dCStats().maxScans; track s.id; let last = $last) {
          <a href="#" (click)="onScanLinkClick(s, $event)">{{ s.sequenceInBatch }}</a>@if (!last) {<span>, </span>}
        }
        )
      }
      (over {{ dCStats().count }}/{{ dCStats().total }} scans with usable values / total scans)
    </li>
    <li>
      max dE: {{ format(dEStats().max) }}
      @if (dEStats().maxScans.length) {
        (scan:
        @for (s of dEStats().maxScans; track s.id; let last = $last) {
          <a href="#" (click)="onScanLinkClick(s, $event)">{{ s.sequenceInBatch }}</a>@if (!last) {<span>, </span>}
        }
        )
      }
      (over {{ dEStats().count }}/{{ dEStats().total }} scans with usable values / total scans)
    </li>

    <li>
      min dC: {{ format(dCStats().min) }}
      @if (dCStats().minScans.length) {
        (scan:
        @for (s of dCStats().minScans; track s.id; let last = $last) {
          <a href="#" (click)="onScanLinkClick(s, $event)">{{ s.sequenceInBatch }}</a>@if (!last) {<span>, </span>}
        }
        )
      }
      (over {{ dCStats().count }}/{{ dCStats().total }} scans with usable values / total scans)
    </li>
    <li>
      min dE: {{ format(dEStats().min) }}
      @if (dEStats().minScans.length) {
        (scan:
        @for (s of dEStats().minScans; track s.id; let last = $last) {
          <a href="#" (click)="onScanLinkClick(s, $event)">{{ s.sequenceInBatch }}</a>@if (!last) {<span>, </span>}
        }
        )
      }
      (over {{ dEStats().count }}/{{ dEStats().total }} scans with usable values / total scans)
    </li>

    <li>
      stddev dE: {{ format(dEStats().stddev) }}
      (over {{ dEStats().count }}/{{ dEStats().total }} scans with usable values / total scans)
    </li>
    <li>
      stddev dC: {{ format(dCStats().stddev) }}
      (over {{ dCStats().count }}/{{ dCStats().total }} scans with usable values / total scans)
    </li>
  </ul>
</div>
